import { POPOVER_CONTENTS } from './MoreQuickFiltersButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { EditIcon, AddIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MAX_CUSTOM_QUICK_FILTERS = 5;
const MoreQuickFiltersPopoverContent = ({
  customPropertyNames,
  overflowingQuickFiltersComponents,
  hasDynamicQuickFiltersEnabled,
  setCurrentPopoverContent
}) => {
  const addButtonDisabled = customPropertyNames.length >= MAX_CUSTOM_QUICK_FILTERS;
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    margin: "400",
    minInlineSize: "440px",
    "data-selenium-test": "MorePopover-container",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      marginBlockEnd: "100",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.quickFiltersBar.moreFilters"
        })
      }), hasDynamicQuickFiltersEnabled && /*#__PURE__*/_jsxs("div", {
        children: [customPropertyNames.length > 0 && /*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.editQuickFilters"
          }),
          children: /*#__PURE__*/_jsxs(Button, {
            "data-selenium-test": "MorePopover-editFilter",
            size: "sm",
            use: "transparent",
            onClick: () => setCurrentPopoverContent(POPOVER_CONTENTS.EDIT_QUICK_FILTERS),
            children: [/*#__PURE__*/_jsx(EditIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.quickFiltersBar.edit"
            })]
          })
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: addButtonDisabled ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.addQuickFilterDisabled"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFiltersUI.quickFiltersBar.addQuickFilter"
          }),
          children: /*#__PURE__*/_jsxs(Button, {
            "data-selenium-test": "MorePopover-addFilter",
            disabled: addButtonDisabled,
            size: "sm",
            use: "transparent",
            onClick: () => setCurrentPopoverContent(POPOVER_CONTENTS.ADD_QUICK_FILTERS),
            children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "customerDataFiltersUI.quickFiltersBar.add"
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(Flex, {
      gap: "100",
      children: overflowingQuickFiltersComponents
    })]
  });
};
export default MoreQuickFiltersPopoverContent;